import api from '../utils/axios';

function asList(data) {
  if (Array.isArray(data)) return data;
  if (data && Array.isArray(data.results)) return data.results;
  if (data && Array.isArray(data.data)) return data.data;
  return [];
}

/**
 * Returns the authenticated user's active Optum onboardings.
 * @returns {Promise<Array>}
 */
export async function listOptumOnboardings() {
  const { data } = await api.get('/optum/onboarding/');
  return Array.isArray(data) ? data : [];
}

/**
 * Triggers an Optum claims pull for all active onboardings.
 * @param {string} serviceStartDate — YYYY-MM-DD
 * @param {string} serviceEndDate   — YYYY-MM-DD
 * @returns {Promise<{jobs_published: number, sync_run_ids: string[], publish_errors: Array}>}
 */
export async function triggerOptumSync(serviceStartDate, serviceEndDate) {
  const { data } = await api.post('/optum/sync/', {
    service_start_date: serviceStartDate,
    service_end_date: serviceEndDate,
  });
  return data;
}

/**
 * Lists Optum document metadata linked to a canonical AppealBot claim.
 * @param {string} claimId
 * @returns {Promise<Array>}
 */
export async function listOptumClaimDocuments(claimId) {
  const { data } = await api.get(`/optum/claims/${claimId}/documents/`);
  return asList(data);
}

/**
 * Queues document/detail fetches so denied-claim appeal evidence is ready.
 * @param {string} claimId
 * @returns {Promise<object>}
 */
export async function prepareOptumClaimDocuments(claimId) {
  const { data } = await api.post(`/optum/claims/${claimId}/prepare-documents/`);
  return data;
}

/**
 * Queues a single Optum document PDF fetch.
 * @param {string} documentId
 * @returns {Promise<object>}
 */
export async function fetchOptumDocument(documentId) {
  const { data } = await api.post(`/optum/documents/${documentId}/fetch/`);
  return data;
}
